(() => {
  let pending = null;
  let openAfterRefresh = false;
  let refreshAgain = false;
  window.jfrNativeCartRefresh = async (open = false) => {
    openAfterRefresh = openAfterRefresh || open;
    if (pending) { refreshAgain = true; return pending; }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    pending = (async () => {
      if (typeof window.jfrNativeDealsSync === 'function') await window.jfrNativeDealsSync();
      const root = window.Shopify.routes.root;
      const url = new URL(location.pathname, location.origin);
      const pageSections = ['main-cart-items', 'main-cart-footer'].map(id => ({id, section: document.getElementById(id)?.dataset.id})).filter(item => item.section);
      url.searchParams.set('sections', ['cart-drawer', 'cart-icon-bubble', ...pageSections.map(item => item.section)].join(','));
      const response = await fetch(url, {headers: {Accept: 'text/html'}, cache: 'no-store'});
      if (!response.ok) throw new Error('Cart refresh failed');
      const sections = await response.json();
      const html = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
      const replacement = html.querySelector('#CartDrawer');
      if (!replacement) throw new Error('Cart section missing');
      drawer.classList.toggle('is-empty', !!html.querySelector('cart-drawer.is-empty'));
      drawer.querySelector('#CartDrawer').replaceWith(replacement);
      replacement.querySelector('#CartDrawer-Overlay').addEventListener('click', () => drawer.close());
      const bubble = document.getElementById('cart-icon-bubble');
      const bubbleHtml = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html');
      const bubbleContent = bubbleHtml.querySelector('.shopify-section');
      if (bubble && bubbleContent) bubble.innerHTML = bubbleContent.innerHTML;
      for (const item of pageSections) {
        const source = new DOMParser().parseFromString(sections[item.section] || '', 'text/html');
        const target = document.querySelector(`#${item.id} .js-contents`);
        const content = source.querySelector('.js-contents');
        if (target && content) target.innerHTML = content.innerHTML;
        if (item.id === 'main-cart-items') {
          const cartItems = document.querySelector('cart-items');
          const sourceItems = source.querySelector('cart-items');
          if (cartItems && sourceItems) cartItems.className = sourceItems.className;
        } else {
          const footer = document.getElementById(item.id);
          const sourceFooter = source.getElementById(item.id);
          if (footer && sourceFooter) footer.classList.toggle('is-empty', sourceFooter.classList.contains('is-empty'));
        }
      }
      window.jfrRenderOfferProgress?.();
      if (openAfterRefresh || drawer.classList.contains('active')) drawer.open();
    })().catch((error) => {
      console.warn('JFR cart refresh:', error.message);
      if (openAfterRefresh) location.assign(window.routes.cart_url);
    }).finally(() => {
      pending = null;
      openAfterRefresh = false;
      if (refreshAgain) {
        refreshAgain = false;
        window.jfrNativeCartRefresh(false);
      }
    });
    return pending;
  };
  window.addEventListener('pplrAddToCartCompleted', () => window.jfrNativeCartRefresh(true));
})();
